function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 142",
  d: "M0 0v26.163h36.722V0zm29.16 3.811l-10.8 8.209-10.8-8.209zM3.811 22.352V5.747l14.553 11.06 14.547-11.06v16.6z",
  fill: "#818181"
});

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.722,
    height: 26.164
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNi43MjIiIGhlaWdodD0iMjYuMTY0IiB2aWV3Qm94PSIwIDAgMzYuNzIyIDI2LjE2NCI+CiAgPHBhdGggaWQ9IlBhdGhfMTQyIiBkYXRhLW5hbWU9IlBhdGggMTQyIiBkPSJNNDEuOTM2LDIwNy44NTN2MjYuMTYzSDc4LjY1OFYyMDcuODUzWm0yOS4xNiwzLjgxMS0xMC44LDguMjA5LTEwLjgtOC4yMDlaTTQ1Ljc0NywyMzAuMjA1VjIxMy42TDYwLjMsMjI0LjY2LDc0Ljg0NywyMTMuNnYxNi42WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxLjkzNiAtMjA3Ljg1MykiIGZpbGw9IiM4MTgxODEiLz4KPC9zdmc+Cg==";
export { SvgMail as ReactComponent };